export default __webpack_public_path__ + "static/682-05494200c9e82b56bc255cae87814e29.gif";